import React, { useEffect, useState } from "react"
import { VMPanelServerConfig } from "common/types/VMPanelServerConfig"
import { useServerConnection } from "../hooks/ServerConnection"
import { VMPanelServerConfigContext } from "../hooks/VMPanelServerConfig"
import { usePromise } from "../hooks/promise"

const LoadVMPanelServerConfig = ({ children }) => {
    const serverConnection = useServerConnection()

    const [serverConfig] = usePromise(() => serverConnection.getServerConfig(), [], null)

    if(serverConfig === null) {
        return <div/>
    }

    return (
        <VMPanelServerConfigContext.Provider value={serverConfig}>
            {children}
        </VMPanelServerConfigContext.Provider>
    )
}

export default LoadVMPanelServerConfig
